// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".molecule-title-and-description[data-v-152b10d6]{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;margin:0 -1.75rem}@media only screen and (max-width:900px){.molecule-title-and-description[data-v-152b10d6]{margin:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
